// Wraps every page: a role without the page's permission sees "No access", also when the URL is typed by hand.
import type { ReactNode } from 'react'
import { NoAccess } from '@/components/NoAccess'
import type { Permission } from '@/constants/permissions'
import { useMe } from './session'

export function RequirePermission({ need, children }: { need?: Permission; children: ReactNode }) {
  const { can } = useMe()
  if (need && !can(need)) return <NoAccess />
  return <>{children}</>
}
